import React from 'react'

import { FeatureFlag } from 'components/auth/FeatureFlag.js'

const StaffOnly = props => <FeatureFlag staffOnly {...props} />

export default StaffOnly
